import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { UserRolePageComponent } from './user-role-page.component';

const routes: Routes = [
  {
    path: 'user-role',
    data: { name: 'User-Role', isTab: true },
    component: UserRolePageComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class UserRolePageRoutingModule {}
